module.exports = __webpack_public_path__ + "static/media/in_progress_grey.6154c0eb.svg";